import { render } from "./PersonalizedPopupForm.vue?vue&type=template&id=5837095b"
import script from "./PersonalizedPopupForm.vue?vue&type=script&lang=js"
export * from "./PersonalizedPopupForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__